import Vue from 'vue';
import Vuex from 'vuex';
import Lockr from 'lockr';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: '',
    user: {}
  },
  getters: {
    getUser: state => {
      return Lockr.get('user');
    },

    getToken: state => {
      return Lockr.get('token');
    }
  },
  mutations: {
    SET_TOKEN (state, obj) {
      state.token = obj;
      Lockr.set('token', obj)
    },

    SET_USER (state, obj) {
      state.user = obj;
      Lockr.set('user', obj)
    },
  },
  actions: {
    setUser ({commit}, obj) {
      commit('SET_USER', obj);
    },
    
    setToken ({commit}, obj) {
      commit('SET_TOKEN', obj);
    },
  }
});

export default store;